export const onSetTrendCursorValues = (trendCursorValues) => ({
    type: 'SET_TREND_CURSOR_VALUES',
    payload: {
        trendCursorValues,
    },
});
export const setTrendCursorValue = (trendCursorValue, trendCursorValuesMap) => {
    var _a;
    const { id, trendCursorId } = trendCursorValue;
    const currentTrendCursorValueMap = (_a = trendCursorValuesMap[trendCursorId]) !== null && _a !== void 0 ? _a : {};
    return {
        ...trendCursorValuesMap,
        [trendCursorValue.trendCursorId]: {
            ...currentTrendCursorValueMap,
            [id]: trendCursorValue,
        },
    };
};
export const setTrendCursorValues = ({ trendCursorValues }, trendCursorValuesMap) => {
    return {
        ...trendCursorValues.reduce((mapping, trendCursorValue) => setTrendCursorValue(trendCursorValue, mapping), trendCursorValuesMap),
    };
};
